import { useEffect, useRef } from 'react'

function useFirstRender(doStuff) {
  const firstRender = useRef(true)

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
      doStuff()
    }
  }, [doStuff])
}

export default useFirstRender
